import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  WhatsappShareButton,
  WhatsappIcon,
  LinkedinIcon,
  LinkedinShareButton,
} from "react-share";

export default function ShareButton(props){
  const { url } = props
  return (
  <>
    <FacebookShareButton url={url} style={{ outline: "none" }}> 
      <FacebookIcon size="32px" round />
    </FacebookShareButton>
    <TwitterShareButton url={url} style={{ marginLeft: `15px`, outline: "none" }}>
      <TwitterIcon size="32px" round />
    </TwitterShareButton>
    <WhatsappShareButton url={url} style={{ marginLeft: `15px`, outline: "none" }}>
      <WhatsappIcon size="32px" round />
    </WhatsappShareButton>
    <LinkedinShareButton url={url} style={{ marginLeft: `15px`, outline: "none" }}>
      <LinkedinIcon size="32px" round />
    </LinkedinShareButton>
  </>
  )
}